"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const isPathNode_1 = __importDefault(require("../../utils/isPathNode"));
const findParentPathOfCurrentPath_1 = __importDefault(require("./findParentPathOfCurrentPath"));
const getBreadcrumbMenu = (pathNodes, flowNodes) => {
    const nodesSortedByParentPath = lodash_1.reduceRight(pathNodes, (finalObj, currentNode) => {
        const parentPath = findParentPathOfCurrentPath_1.default(flowNodes, currentNode);
        if (parentPath) {
            const existingSiblings = lodash_1.get(finalObj, [parentPath.id, 'childPaths'], []);
            const maybeAlreadyPlacedChild = finalObj[currentNode.id];
            const childWithItsChildren = !maybeAlreadyPlacedChild
                ? currentNode
                : maybeAlreadyPlacedChild;
            finalObj[parentPath.id] = Object.assign(Object.assign({}, parentPath), { childPaths: [childWithItsChildren, ...existingSiblings] });
            if (finalObj[currentNode.id]) {
                delete finalObj[currentNode.id];
            }
        }
        else if (isPathNode_1.default(currentNode) && !finalObj[currentNode.id]) {
            finalObj[currentNode.id] = currentNode;
        }
        return finalObj;
    }, {});
    return lodash_1.values(nodesSortedByParentPath);
};
exports.default = getBreadcrumbMenu;
